import request from '@/utils/request';
import request2 from '@/utils/request2';
// 短信验证码验证
export function smsVerify(data) {
  return request.post('send/sms-verify', data);
}
// 注销账号admin/user/logOff
export function logOff(data) {
  return request.post('admin/user/logOff', data);
}
// 校验账号密码是否正确admin/user/checkAccountPassword
export function checkAccountPassword(data) {
  return request.post('admin/user/checkAccountPassword', data);
}
// 7天不再提示
export function notPrompt(data = {}) {
  return request.post('admin/user/notPrompt', data);
}
// 修改手机号或密码admin/user/updatePasswordOrPhone
export function updatePasswordOrPhone(data) {
  return request.post('admin/user/updatePasswordOrPhone', data);
}
// 总系统-编辑个人信息
export function editPersonalInformation(data) {
  return request.post('admin/user/edit-personal-information', data);
}
// 客户系统-编辑个人信息
export function editPersonalInformationCustomer(data) {
  return request2.post('admin/user/edit-personal-information', data);
}